<script lang="ts" setup>
import Page from './Page.vue'
import { Routes } from '~/enums/Routes'
import LayoutEnum from '~/enums/LayoutEnum'
import { PagesPrefixEnum } from '~/enums/PagesPrefixEnum'
import { useIdentity } from '~/store/identity'

const { isPerkuJavTheme, isWhitelabel } = useTheme()
const identity = useIdentity()
const route = useRoute()

watch(
  async () => await identity.getUser(),
  async (getUser) => {
    if ((isWhitelabel || isPerkuJavTheme) && route.name === `${PagesPrefixEnum}${Routes.Market}`) {
      return navigateTo(getLocalizedRoute(Routes.Index))
    }

    const user = await getUser

    if ((isWhitelabel || isPerkuJavTheme) && !user && route.name !== `${PagesPrefixEnum}${Routes.Index}`) {
      return navigateTo(getLocalizedRoute(Routes.Login))
    }
  }
)
</script>

<template>
  <div>
    <Page :is-full-width="true">
      <template #header>
        <div>
          <LayoutHeader :type="LayoutEnum.Market" />
        </div>
      </template>
      <slot />
    </Page>
  </div>
</template>
